import script from "./LoginView.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginView.vue?vue&type=script&setup=true&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=3a952b80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a952b80"]])

export default __exports__